import { render, staticRenderFns } from "./ManageProjectTemplates.vue?vue&type=template&id=5f91330a"
import script from "./ManageProjectTemplates.vue?vue&type=script&lang=js"
export * from "./ManageProjectTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports